export default __webpack_public_path__ + "locales/sl/ChangePhoneDialog.json?hash=58e7882ec1a96fd14de90de75bb1a563";